"use client";

import { useEffect } from "react";

type AccessGateProps = {
  title: string;
  message: string;
  redirectMessage: string;
  primaryHref: string;
  primaryLabel: string;
  secondaryHref: string;
  secondaryLabel: string;
  footer: string;
  loaderText?: string;
  autoRedirectHref?: string;
  autoRedirectDelayMs?: number;
};

export default function AccessGate({
  title,
  message,
  redirectMessage,
  primaryHref,
  primaryLabel,
  secondaryHref,
  secondaryLabel,
  footer,
  loaderText,
  autoRedirectHref,
  autoRedirectDelayMs,
}: AccessGateProps) {
  useEffect(() => {
    if (!autoRedirectHref || !autoRedirectDelayMs) return;
    const t = window.setTimeout(() => {
      window.location.href = autoRedirectHref;
    }, autoRedirectDelayMs);
    return () => window.clearTimeout(t);
  }, [autoRedirectDelayMs, autoRedirectHref]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-[#f6f7fb] p-6">
      <div className="w-full max-w-xl rounded-2xl border border-black/10 bg-white p-8 shadow-sm">
        <div className="text-2xl font-semibold text-[#272727]">
          {title}
        </div>
        <p className="mt-3 text-sm leading-6 text-gray-600">
          {message}
        </p>
        <p className="mt-2 text-sm leading-6 text-gray-600">
          {redirectMessage}
        </p>
        {loaderText ? (
          <div className="mt-5 flex items-center gap-2 text-sm text-gray-500">
            <span className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-black/20 border-t-black" />
            <span>{loaderText}</span>
          </div>
        ) : null}
        <div className="mt-6 flex flex-col gap-3 sm:flex-row">
          <a
            href={primaryHref}
            className="inline-flex items-center justify-center rounded-lg bg-[#272727] px-4 py-3 text-sm font-medium text-white hover:bg-black"
          >
            {primaryLabel}
          </a>
          <a
            href={secondaryHref}
            className="inline-flex items-center justify-center rounded-lg border border-black/10 px-4 py-3 text-sm font-medium text-[#272727] hover:bg-gray-50"
          >
            {secondaryLabel}
          </a>
        </div>
        <div className="mt-4 text-xs text-gray-500">
          {footer}
        </div>
      </div>
    </main>
  );
}
